"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".about-us[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{text-indent:50px;text-align:justify}"];
exports.styles = styles;
